import { FormTitleProps } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { isNil } from 'lodash';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { RPDF } from 'src/features/report/react-pdf';
import { ReportColors } from 'src/features/report/report-colors';

export type AnswerPreviewRowType<T> = FormTitleProps & {
  isOptional?: boolean;
  value: T | undefined | null;
  renderValue: (value: T) => React.JSX.Element | string;
};

export const AnswerPreviewRow = <T,>(props: AnswerPreviewRowType<T>) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Validation');
  const localStyles = RPDF.StyleSheet.create({
    field: {
      flexDirection: 'row',
      paddingVertical: 8,
      gap: 24,
      ...RPDF.tableStyles.divider,
    },
    leftPart: {
      flex: 1,
      flexDirection: 'row',
      columnGap: 4,
    },
    prefix: {
      ...RPDF.typography.heading5b,
      color: ReportColors.plain,
    },
    title: {
      ...RPDF.typography.heading5,
    },
    optional: {
      ...RPDF.typography.text8,
      color: ReportColors.plain,
    },
    value: {
      ...RPDF.typography.text8,
      flex: 1,
      flexDirection: 'column',
    },
    valueItem: {
      flexDirection: 'row',
      columnGap: 4,
    },
  });

  return (
    <RPDF.View wrap={false} style={localStyles.field}>
      <RPDF.View style={localStyles.leftPart}>
        {props.prefix && <RPDF.Text style={localStyles.prefix}>{props.prefix}</RPDF.Text>}
        {props.title && <RPDF.Text style={localStyles.title}>{props.title}</RPDF.Text>}
        {props.title && props.isOptional && <RPDF.Text style={localStyles.optional}>{t('Optional')}</RPDF.Text>}
      </RPDF.View>
      {!isNil(props.value) && <RPDF.Text style={localStyles.value}>{props.renderValue(props.value)}</RPDF.Text>}
    </RPDF.View>
  );
};
